import { useEffect } from "react";

// react-hubspot-form requires jQuery to handle onSubmit events
// so this hook creates a custom listener to handle it instead
export const useHubspotFormSubmitListener = (onSubmit?: () => void) => {
  useEffect(() => {
    const handleHubspotEvent = (event: any) => {
      if (
        onSubmit &&
        event.data.type === "hsFormCallback" &&
        event.data.eventName === "onFormSubmitted"
      ) {
        onSubmit();
      }
    };
    window.addEventListener("message", handleHubspotEvent);
    return () => window.removeEventListener("message", handleHubspotEvent);
  }, []);
};
